const dialogContent = {
  styleOverrides: {
    root: ({ theme }: { theme: any }) => ({
      padding: theme.spacing(2.5),
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    }),
    dividers: ({ theme }: { theme: any }) => ({
      borderTop: `${theme.borders.borderWidth[1]} solid ${theme.palette.divider}`,
      borderBottom: `${theme.borders.borderWidth[1]} solid ${theme.palette.divider}`,
    }),
  },
};

export default dialogContent;
